import { CFormSwitch } from '@coreui/react'
import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion'
import ArrowDown from '../../assets/arrow-down.svg'

const CustomAccordion = ({
  items,
  styles,
  titleTextStyle = {
    fontSize: '20px',
    fontWeight: 500,
  },
}) => {
  const getItemProps = (info) => {
    let itemsProps = {}
    if (info?.enableSwitch || info.expanded) {
      itemsProps = {
        dangerouslySetExpanded: info?.expanded || (info?.enableSwitch && info?.switchChecked),
      }
    }
    return itemsProps
  }

  return (
    <Accordion allowZeroExpanded className={`w-100 ${styles}`}>
      {items.map((info, index) => {
        const itemProps = getItemProps(info)

        return (
          <AccordionItem
            style={{
              pointerEvents: info?.enableSwitch && !info?.switchChecked ? 'none' : 'auto',
              backgroundColor: info?.enableSwitch && !info?.switchChecked ? '#ececec' : '#ffffff',
            }}
            className={`accordion-full ${info.itemStyle}`}
            key={index}
            {...itemProps}
          >
            <AccordionItemHeading className="">
              <AccordionItemButton
                className="accordion-box flex justify-content-between align-items-center"
                style={{
                  height: info.accordionHeight ? info.accordionHeight : '',
                  paddingRight: info.accordionPaddingRight ? info.accordionPaddingRight : '',
                }}
              >
                <div className=" flex align-items-center">
                  {info?.logo && <img src={info.logo} style={info.logoStyle} />}
                  <div className=" flex flex-column">
                    <div className="d-flex align-items-center">
                      <span style={titleTextStyle}>{info.title}</span>
                      {info?.enableSwitch && (
                        <CFormSwitch
                          style={{ pointerEvents: 'initial' }}
                          className="mx-4"
                          label=""
                          id="accordionSwitch"
                          value={info?.switchChecked}
                          checked={info?.switchChecked}
                          valid={true}
                          onChange={(e) => info?.switchToggle(e)}
                        />
                      )}
                    </div>

                    <span style={{ fontSize: '11px', textAlign: 'left' }}>{info.description}</span>
                  </div>
                </div>
                {info?.hideArrow ? (
                  ''
                ) : (
                  <div
                    style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                    className={`"h-[28.2px] w-[28.2px] rounded-full ${
                      info?.enableSwitch && !info?.switchChecked ? 'bg-[#7f817f]' : 'bg-[#2172eb]'
                    } bg-[#2172eb] flex justify-center items-center cursor-pointer"`}
                  >
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <img src={ArrowDown} alt="ArrowDown" className="rotateimg180" />
                        ) : (
                          <img src={ArrowDown} alt="ArrowDown" />
                        )
                      }
                    </AccordionItemState>
                  </div>
                )}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>{info.children}</AccordionItemPanel>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default CustomAccordion
